import { render, staticRenderFns } from "./TablaRecibosAdmin.vue?vue&type=template&id=6d361c6c&"
import script from "./TablaRecibosAdmin.vue?vue&type=script&lang=js&"
export * from "./TablaRecibosAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports